'use strict';

function appLinkDebugger() {
  // 只在开发环境输出
  if (module.hot) {
    var _console;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (_console = console).log.apply(_console, ['%c[AppLink]', 'background:#222;color:#bada55;font-size:1.5em'].concat(args));
  }
}

module.exports = appLinkDebugger;